import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const hotspotSize = 17

const styles = theme => ({
  hotspotContainer: {
    position: 'absolute',
    zIndex: 1,
    cursor: 'pointer',
    backgroundColor: '#303c49',
    border: 'solid 1px #e2e3e4',
    borderRadius: '99px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 8px 6px -8px rgba(0, 0, 0, 0.14)'
  },
  hotspotStyle: {
    width: hotspotSize,
    height: hotspotSize
  },
  labelStyle: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    fontStretch: 'condensed',
    lineHeight: 1.29,
    color: '#ffffff',
    userSelect: 'none'
  },
  iconWrapper: {
    fontSize: 0,
    display: 'inline-block',
    padding: '10px'
  },
  lightHotspotContainer: {
    position: 'absolute',
    zIndex: 1,
    cursor: 'pointer',
    backgroundColor: '#e40045',
    border: 'solid 1px #e2e3e4',
    borderRadius: '99px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 8px 6px -8px rgba(0, 0, 0, 0.14)'
  },
  lightLabelStyle: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    fontStretch: 'condensed',
    lineHeight: 1.29,
    color: '#303c49',
    userSelect: 'none'
  }
})

const ActiveHotspot = withStyles(styles)(({ size, classes, ...otherProps }) => {
  return (
    <SvgIcon
      viewBox={`0 0 ${size} ${size}`}
      classes={{ root: classes.hotspotStyle }}
      {...otherProps}
    >
      <g>
        <circle cx="8.5" cy="8.5" r="7" fill="#e40045" />
      </g>
    </SvgIcon>
  )
})
const InactiveHotspot = withStyles(styles)(
  ({ size, light, classes, ...otherProps }) => {
    return (
      <SvgIcon
        viewBox={`0 0 ${size} ${size}`}
        classes={{ root: classes.hotspotStyle }}
        {...otherProps}
      >
        <g>
          {/* <circle cx="8.5" cy="8.5" r="7" fill="#303c49" /> */}
          <circle
            cx="8.5"
            cy="8.5"
            r="7"
            fill="transparent"
            stroke={light ? '#fff' : '#e40045'}
            strokeWidth="3"
          />
        </g>
      </SvgIcon>
    )
  }
)

class HotspotWithLabel extends Component {
  state = {
    active: this.props.active
  }

  componentWillReceiveProps({ active }) {
    this.setState({ active })
  }

  render() {
    const {
      posX,
      posY,
      textAlign,
      label,
      onHotspotClick,
      light,
      classes: {
        hotspotContainer,
        labelStyle,
        iconWrapper,
        lightHotspotContainer
      }
    } = this.props

    const { active } = this.state

    return (
      <div
        className={!active && light ? lightHotspotContainer : hotspotContainer}
        style={{
          top: `calc(${posY}% - ${(posY / 100) * hotspotSize}px)`,
          left: `calc(${posX}% - ${(posX / 100) * hotspotSize}px)`
        }}
        onClick={onHotspotClick}
      >
        {textAlign === 'left' && (
          <span className={labelStyle} style={{ paddingLeft: '16px' }}>
            {label}
          </span>
        )}
        <span className={iconWrapper}>
          {active ? (
            <ActiveHotspot size={hotspotSize} />
          ) : (
            <InactiveHotspot size={hotspotSize} light={light} />
          )}
        </span>
        {textAlign === 'right' && (
          <span className={labelStyle} style={{ paddingRight: '16px' }}>
            {label}
          </span>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(HotspotWithLabel)



// WEBPACK FOOTER //
// ./src/components/HotspotWithLabel.js